module.exports = __webpack_public_path__ + "static/media/weighing.e36ab30e.jpg";